import { default as RoomPanel } from './RoomPanel';
import type { Room } from '../components/RoomSelector/RoomSelector.types';
import { getStore } from '../store/store';
import { convertOpxEvent } from '../utils/convertOpxEvent';
import { onCloseRoomPanel } from '../utils/onCloseRoomPanel';
import { observer } from 'mobx-react-lite';
import type { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { generateColorScheme } from 'owa-color-utils/lib/colorUtils';
import { getOpxHostApi } from 'owa-opx';
import { DEFAULT_OUTLOOK_THEME_COLOR, getPaletteAsRawColors } from 'owa-theme';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import * as React from 'react';

export default observer(function RoomPanelOpx() {
    React.useEffect(() => {
        if (isHostAppFeatureEnabled('opxComponentLifecycle')) {
            getOpxHostApi().onPageReady();
        }
    }, []);

    const onRoomAdded = React.useCallback((room: Room) => {
        if (isHostAppFeatureEnabled('roomAddedHandler')) {
            getOpxHostApi().onRoomAdded(room.email);
        }
    }, []);

    const primaryHexColor = isHostAppFeatureEnabled('defaultOutlookThemeColor')
        ? DEFAULT_OUTLOOK_THEME_COLOR
        : getPaletteAsRawColors().themePrimary;
    const colorScheme = React.useRef<ColorScheme>(generateColorScheme(primaryHexColor));

    const data = getStore().opxRoomFinderData;
    const event = convertOpxEvent(data?.event);
    const showHeader = !data || data.showHeader;

    return (
        <RoomPanel
            onRoomAdded={onRoomAdded}
            onClose={onCloseRoomPanel}
            event={event}
            colorScheme={colorScheme.current}
            source={'DeepLink'}
            hideHeader={!showHeader}
        />
    );
});
